import { createFileRoute } from '@tanstack/react-router'
import { Telas } from '@/features/telas/Telas'

export const Route = createFileRoute('/_app/app/telas')({
  staticData: { crumb: { label: 'Telas' } },
  component: Telas,
})
